import { useEffect, useState } from "react";
import APIs from "../../APIs";
import { useNavigate } from "react-router-dom";
import Sidebar from "./Sidebar";
import DashboardHeader from "./DashboardHeader";
import { useDispatch } from "react-redux"; // you imported useSelector but not using it
import MyBookings from "./MyBookings";
import Quotation from "./Quotation";
const Dashboard = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const dispatch = useDispatch();

  const userData = JSON.parse(sessionStorage.getItem("userData"));
  const user_id = userData?.user_id;

  useEffect(() => {
    fetchOrders();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchOrders = async () => {
    try {
      if (!user_id) return;

      const res = await APIs.post(
        "booking/getDashboard",
        { user_id },
        { headers: { "Content-Type": "application/json" } }
      );

      const currentOrders =
        res.data.data.currentOrders ||
        res.data.data.currentOrders ||
        [];

      setOrders(currentOrders);
      console.log("Dashboard fetchOrders response:", res.data.data.currentOrders);
    } catch (error) {
      console.error("Error fetching orders:", error);
      setOrders([]);
    }
  };
const formatOrderDate = (dateStr) => {
  if (!dateStr) return "N/A";

  // "29-09-2025 13:27:00"
  const [datePart, timePart] = dateStr.split(" ");
  const [day, month, year] = datePart.split("-");

  const formattedDate = new Date(`${year}-${month}-${day}T${timePart}`);

  if (isNaN(formattedDate)) return "N/A";

  return formattedDate.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

  return (
    <div className="page-content">
      <section className="step-section-md">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <Sidebar />
            </div>

            <div className="col-lg-9">
              <DashboardHeader />

              {/* Current Orders */}
              <div className="card mt-30">
                <MyBookings />
                {/* <Quotation /> */}
              </div>
              {/* End Current Orders */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
